import {ChangeDetectorRef, Component, NgZone, OnInit, Pipe, PipeTransform} from '@angular/core';
import { GasStationModel, TrailerModel } from '@core/api';
import { Router } from '@angular/router';
import { StationService } from '@accounts/user/services/station.service';
import { MatBottomSheetRef } from '@angular/material';
import {MapService} from "@accounts/user/services/map.service";

interface LocationGroup {
  name: string;
  stations: GasStationModel[];
}

@Component({
  selector: 'popup-locations-list',
  templateUrl: './locations-list.component.html',
  styleUrls: ['./locations-list.component.scss']
})
export class LocationsListComponent implements OnInit {
  stations: GasStationModel[] = [];
  loading: boolean = true;
  locations: LocationGroup[] = [];

  constructor(
    private router: Router,
    public stationService: StationService,
    private bottomSheetRef: MatBottomSheetRef<LocationsListComponent>,
    private cdr: ChangeDetectorRef,
    private mapService: MapService,
  ) {

    this.stationService.getNStations(50).subscribe(data => {
      this.stations = data;

      this.stations.forEach(station => {
        if (station.location_group === null) {
          station.location_group = 'Другие';
        }

        if (!this.locations.find(location => location.name === station.location_group)) {
          this.locations.push({
            name: station.location_group,
            stations: [],
          });
        }

        this.locations.find(location => location.name === station.location_group).stations.push(station);
      });

      this.locations.sort((a, b) => {
        if (a.name === "Минск") return -1;
        if (b.name === "Минск") return 1;
        if (a.name === "Другие") return 1;
        if (b.name === "Другие") return -1;

        return a.name.localeCompare(b.name, "ru", { sensitivity: "base" });
      });

      this.loading = false;
      this.cdr.detectChanges();
    });

  }

  ngOnInit() {

  }

  selectStation(station: GasStationModel) {
    this.mapService.goToCurrentStation(station.coordinate_latitude, station.coordinate_longitude);
    this.bottomSheetRef.dismiss();
  }
}